<template>
  <section class="uploadSentenceGroupPage">
    <popup
      v-show="isShowUploadSentenceGroup"
      bread="教材管理,课程管理,设置主题资料,编辑句型组资料"
      title="上传句型组资料"
      @onBack="popup_back"
    >
      <template slot="button">
        <el-button
          type="success"
          @click="saveUploadSentenceGroup"
        >保存并上传</el-button>
      </template>
      <infoUpDown :bread="'编辑句型组资料'">
        <h3 class="group-tit">句型组资料</h3>
        <el-form
          ref="ref_commonForm"
          class="common-form-self"
          :model="form"
          :rules="rules"
          label-width="100px"
          @submit.native.prevent
        >
          <div
            class="card"
            style="margin-bottom:0;"
          >
            <div class="sentence-cell">
              <el-form-item
                label="句型组名称"
                prop="groupName"
                :rules="[
                  { required: true, message: '请输入句型组名称', trigger: 'blur' },
                  { validator: validateSentence, message: '请输入句型组名称', trigger: 'blur' }]"
              >
                <el-input
                  v-model="form.groupName"
                  maxlength="100"
                  placeholder="请输入句型组名称"
                />
              </el-form-item>
              <!-- <el-form-item
                label="句型组读音"
                prop="groupVoice"
              >
                <themeUploadList
                  code="jxzVoice"
                  :file-list.sync="form.groupVoice"
                  accept=".mp3,.wmv"
                  :limit="1"
                  tip="仅支持.mp3文件"
                />
              </el-form-item>
              <el-form-item
                label="封面图"
                prop="groupImg"
              >
                <themeUploadAvatar
                  code="jxzImg"
                  :file-list.sync="form.groupImg"
                />
              </el-form-item> -->
            </div>
          </div>
          <div style="width:100%">
            <h3 class="group-tit">句型</h3>
          </div>
          <div
            v-for="(item, index) in form.sentenceList"
            :key="item.key"
            class="card"
          >
            <div class="cont">
              <div
                v-for="(cell, index2) in item.cellList"
                :key="cell.key"
                class="sentence-cell"
              >
                <el-form-item
                  label="句型"
                  :prop="'sentenceList.' + index + '.cellList.'+ index2 + '.word'"
                  :rules="[
                    { required: true, message: '请输入句型', trigger: 'blur'},
                    { validator: validateSentence, message: '请输入句型',trigger: 'blur' }
                  ]"
                >
                  <el-input
                    v-model="cell.word"
                    maxlength="100"
                    placeholder="请输入句型名称"
                  />
                </el-form-item>
                <el-form-item
                  style="width: 30%;"
                  label="句型读音"
                  :prop="'sentenceList.' + index + '.cellList.'+ index2 + '.voice'"
                  :rules="{
                    type: 'array', required: true, message: '请上传句型读音音频', trigger: 'change'
                  }"
                >
                  <themeUploadList
                    code="jxzVoice"
                    :file-list.sync="cell.voice"
                    accept=".mp3,.wmv"
                    :limit="1"
                    tip="仅支持.mp3文件"
                  />
                </el-form-item>
                <el-form-item
                  class="self-form-item"
                  style="width: 18%;margin-right: 0;"
                >
                  <el-button
                    v-if="isShowCellAdd(index, index2)"
                    type="success"
                    size="mini"
                    @click="addCell(index)"
                  >添加</el-button>
                  <el-button
                    v-if="item.cellList.length > 1"
                    type="warning"
                    size="mini"
                    @click="deleteCell(index, index2)"
                  >删除</el-button>
                  <!-- <i v-if="item.cellList.length > 1" class="small-icon el-icon-remove" @click="deleteCell(index, index2)" />
                  <i v-if="isShowCellAdd(index, index2)" class="small-icon el-icon-circle-plus" @click="addCell(index)" /> -->
                </el-form-item>
              </div>
              <el-form-item
                label="卡片图"
                :prop="'sentenceList.' + index + '.img'"
                :rules="rules.img"
              >
                <themeUploadAvatar
                  code="jxzImg"
                  :file-list.sync="item.img"
                />
              </el-form-item>

            </div>
            <div class="button-bar">
              <el-button
                v-if="isShowAdd(index)"
                type="success"
                size="small"
                @click="addCard"
              >添加句型</el-button>
              <el-button
                v-if="form.sentenceList.length > 1"
                type="warning"
                size="small"
                @click="deleteCard(index)"
              >删除</el-button>
              <!-- <i v-if="isShowAdd(index)" class="el-icon-circle-plus" @click="addCard()" />
              <i v-if="form.sentenceList.length > 1" class="el-icon-remove" @click="deleteCard(index)" /> -->
            </div>
          </div>

        </el-form>
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import themeUploadAvatar from '../components/themeUploadAvatar'
import themeUploadList from '../components/themeUploadList'
import _ from 'lodash'
// import { regForFilter } from '../../../../utils/reg'
import { serachDetail, editSentenceGroupPattern } from '../../../../api/teachBookManagement/courseManagement'
import { mapState } from 'vuex'
export default {
  components: {
    themeUploadAvatar,
    themeUploadList
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadSentenceGroup: false,
      form: {
        groupName: '',
        // groupVoice: [],
        // groupImg: [],
        sentenceList: [
          {
            cellList: [
              { word: '', voice: [], key: Date.now() }
            ],
            img: [],
            key: Date.now()
          }
        ]
      },
      rules: {
        // groupVoice: [{ type: 'array', required: true, message: '请上传句型组读音音频', trigger: 'change' }],
        // groupImg: [{ type: 'array', required: true, message: '请上传卡片图', trigger: 'change' }],
        img: [{ type: 'array', required: true, message: '请上传卡片图', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState('settingThemeData', ['editSentenceGroupList'])
  },
  watch: {
    timestamp: function (val) {
      this.isShowUploadSentenceGroup = true
      this.fetchData(this.editSentenceGroupList[0].id)
    }
  },

  created () {
  },
  methods: {
    async fetchData(id) {
      try {
        const res = await serachDetail({ id: id })
        this.dataChange(res)
      } catch (error) {
        console.log(error)
        this.popup_back()
      }
    },
    // 把数据转换成需要的格式
    dataChange (objs) {
      const moment = {}
      moment.groupName = objs.wordName
      moment.id = objs.id
      // moment.groupImg = [{
      //   name: objs.cardChartName,
      //   url: objs.cardChartPath,
      //   id: objs.id
      // }]
      // moment.groupVoice = [{
      //   name: objs.pronunciationName,
      //   url: objs.pronunciationPath,
      //   id: objs.id
      // }]
      moment.sentenceList = []
      for (const i of objs.basicMeansResList) {
        const array = {
          cellList: [],
          img: [{
            id: objs.id,
            name: i.cardChartName,
            url: i.rootCardChartPath,
            fileName: i.cardChartFileName,
            matchPathName: i.cardChartPath
          }]
        }
        for (const y of i.sentencePatternReadRes) {
          const item = {
            word: y.sentencePatternName,
            voice: [{
              name: y.sentencePronunciationFileName,
              url: y.rootSentencePronunciationPath,
              fileName: y.sentencePronunciationName,
              matchPathName: y.sentencePronunciationPath
            }]
          }
          array.cellList.push(item)
        }
        moment.sentenceList.push(array)
      }
      this.form = _.cloneDeep(moment)
    },
    validateSentence (rule, value, callback) {
      if (value.split(' ').join('').length === 0) {
        callback(new Error('请输入句型组名称'))
      } else {
        callback()
      }
    },
    // 返回
    popup_back () {
      this.$refs['ref_commonForm'].resetFields()
      this.isShowUploadSentenceGroup = false
      // this.$emit('resetFetchData')
    },
    isShowAdd (index) {
      return (this.form.sentenceList.length - 1) === index && this.form.sentenceList.length < 20
    },
    addCard () {
      this.form.sentenceList.push({ cellList: [{ word: '', voice: [], key: Date.now() }], img: [], key: Date.now() })
    },
    deleteCard (index) {
      this.$confirm('是否确认删除句型?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.form.sentenceList.splice(index, 1)
      })
    },
    isShowCellAdd (index, index2) {
      return (this.form.sentenceList[index].cellList.length - 1) === index2 && this.form.sentenceList[index].cellList.length < 6
    },
    addCell (index) {
      this.form.sentenceList[index].cellList.push({ word: '', voice: [], key: Date.now() })
    },
    deleteCell (index, index2) {
      this.form.sentenceList[index].cellList.splice(index2, 1)
    },
    saveUploadSentenceGroup () {
      this.$refs['ref_commonForm'].validate(async (valid) => {
        if (!valid) {
          this.$message.error('请正确填写信息')
          return false
        }
        console.log(this.form)
        const params = {
          id: this.form.id,
          teachingThemeId: this.themeRow.id,
          meansType: 7,
          groupName: this.form.groupName.trim(),
          // cardChartGroupName: this.form.groupImg[0].paramsFileName || this.form.groupImg[0].name,
          // cardChartGroupPath: this.form.groupImg[0].paramsUrl || regForFilter(this.form.groupImg[0].url),
          // sentencePronunciationGroupName: this.form.groupVoice[0].paramsFileName || this.form.groupVoice[0].name,
          // sentencePronunciationGroupPath: this.form.groupVoice[0].paramsUrl || regForFilter(this.form.groupVoice[0].url),
          sentencePatternAddRes: []
        }
        for (const i in this.form.sentenceList) {
          params.sentencePatternAddRes.push({
            cardChartName: this.form.sentenceList[i].img[0].paramsFileName || this.form.sentenceList[i].img[0].name,
            cardChartPath: this.form.sentenceList[i].img[0].matchPathName || this.form.sentenceList[i].img[0].paramsUrl,
            meansType: 8,
            sentencePatternReadRes: []
          })
          for (const item2 of this.form.sentenceList[i].cellList) {
            params.sentencePatternAddRes[i].sentencePatternReadRes.push({
              sentencePatternName: item2.word.trim(),
              sentencePronunciationName: item2.voice[0].paramsFileName || item2.voice[0].fileName,
              sentencePronunciationPath: item2.voice[0].matchPathName || item2.voice[0].paramsUrl
            })
          }
        }
        console.log(params)
        try {
          await editSentenceGroupPattern(params)
          this.$message.success('修改成功')
          this.popup_back()
          this.$emit('resetFetchData')
        } catch (e) {
          this.$message.closeAll()
          this.$message.error(e)
        }
      })
    }

  }
}
</script>

<style lang='scss'>
.uploadSentenceGroupPage {
  .group-tit {
    margin: 24px 0;
    color: #53402b;
    display: flex;
    align-items: center;
    span {
      color: #898884;
    }
    &::before {
      content: "";
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #fcda6f;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
  .common-form-self {
    display: flex;
    flex-wrap: wrap;
    & > .el-form-item {
      width: 40%;
      &:nth-child(odd) {
        margin-right: 10%;
      }
    }
    .card {
      width: 100%;
      border: 1px solid #eeeeee;
      border-radius: 8px;
      padding: 24px 0 0 0;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
      .cont {
        border-bottom: 1px solid #eeeeee;
      }
      .sentence-cell {
        display: flex;
        flex-wrap: wrap;
        .el-form-item {
          width: 40%;
          &:nth-child(odd) {
            margin-right: 10%;
          }
        }
      }
      .button-bar {
        margin-right: 20px;
        padding: 10px 0;
        text-align: right;
      }
      .small-icon {
        padding: 5px;
        cursor: pointer;
        font-size: 26px;
        color: #fbb04f;
      }
      .small-icon + .small-icon {
        margin-left: 15px;
      }
    }
  }
  .self-form-item {
    width: 15%;
    margin-right: 0;
    .el-form-item__content {
      margin-left: 50px !important;
    }
  }
}
</style>
